import { FormCallToActions } from "shared-components/Contexts/ContactModal/context";
import { PropComponentMode } from "../../PropertyInterfaces";

export enum ModalState {
	CLOSE,
	DEFAULT,
	OPEN,
}
export type ModalStatus = {
	similarModal: ModalState;
	contactLead: ModalState;
};

export type ButtonsLeadsSource = "card" | "contactModal" | "propertyDetail" | "propertyDetailMain" | "affixBottom" | ""

export type CTAButtons = {
	phone: boolean,
	whatsapp: boolean,
	contact: boolean
}

export interface TextFormProps {
	autoFocus?: boolean;
	ctaToShow: FormCallToActions
	defaultMessage?: string;
	disabled?: boolean;
	expressCallback?: ((e) => void) | null;
	id: number;
	isExpress?: boolean
	isFromModal?: boolean;
	isInListing?: boolean;
	isProject?: boolean;
	isProjectSpecialPage?: boolean;
	onComplete?: (() => void) | null;
	owner?: any;
	propertyLink?: string;
	queryRouter?: string;
	showTextInput?: boolean;
	slug?: string;
	source?: ButtonsLeadsSource;
}
